import { render, staticRenderFns } from "./AdminChargesTable.vue?vue&type=template&id=2d3f043a"
import script from "./AdminChargesTable.vue?vue&type=script&lang=js"
export * from "./AdminChargesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d3f043a')) {
      api.createRecord('2d3f043a', component.options)
    } else {
      api.reload('2d3f043a', component.options)
    }
    module.hot.accept("./AdminChargesTable.vue?vue&type=template&id=2d3f043a", function () {
      api.rerender('2d3f043a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminChargesTable.vue"
export default component.exports